import React from "react";

import { selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";
import { useAppSelector } from "store";

const Subtitle: React.FC = () => {
    const store = useAppSelector(selectStore);

    return (
        <>
            See when footfall peaks around your {store?.name} store and how long people tend to stay.
            Use this to help plan staff rotas, run promotions at the right times, and take care of
            quieter tasks when things are less busy.
        </>
    );
};

export default Subtitle;
